<template lang="pug">
  v-card
    v-toolbar(:color="theme.colors.primary" dark)
      v-toolbar-title {{ title }}
    v-card-text
      slot
    div(class="grey lighten-4 pa-3")
      v-card-actions
        slot(name="actions")
</template>
<script>
import { mapState } from 'vuex';

export default {
  props: {
    title: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState({
      theme: s => s.config.theme
    })
  }
};
</script>
